import type { StyleRule } from '@archipro-design/aria';
import {
    tileImageClassName,
    tileImageSlotClassNames,
} from '@archipro-design/aria';
import {
    pxToRem,
    tileOverlayClassName,
    tileOverlaySlotClassNames,
} from '@archipro-design/aria';
import { PRODUCT_TAGGING_REVEAL_TRANSITION_ICONS } from '../../constant';

export const TagModalsContainer: StyleRule = () => ({
    position: 'absolute',
    opacity: 0,
    visibility: 'hidden',
    transition: PRODUCT_TAGGING_REVEAL_TRANSITION_ICONS,
});

// content display after the tag, arrow on the left side of the content
export const TooltipContentAfter: StyleRule = () => ({
    [`& > div:first-child`]: {
        '&::before': {
            borderWidth: '19rem 21rem 19rem 0',
            top: '-10rem',
            left: '-5rem',
        },
        '&::after': {
            display: 'none',
        },
    },
});

// content display before the tag, arrow on the right side of the content
export const TooltipContentBefore: StyleRule = () => ({
    [`& > div:first-child`]: {
        '&::before': {
            borderWidth: '19rem 0 19rem 19rem',
            top: '-10rem',
            left: '-5rem',
        },
        '&::after': {
            display: 'none',
        },
    },
});

export const ProductTagTile: StyleRule<{ showHover: boolean }> = ({
    theme,
    showHover,
}) => ({
    opacity: showHover ? 1 : 0,
    visibility: showHover ? 'visible' : 'hidden',
    transition: PRODUCT_TAGGING_REVEAL_TRANSITION_ICONS,
    zIndex: theme.siteVariables.zIndexes.overlay,
    boxShadow: `0px 14px 24px 2px rgba(0, 0, 0, 0.08)`,
    background: theme.siteVariables.colors.white['000'],

    [`& .${tileImageClassName}`]: {
        width: pxToRem(240),
        height: pxToRem(240),
        borderRadius: 0,

        [`& .${tileImageSlotClassNames.imageContainer}`]: {
            width: pxToRem(240),
            height: pxToRem(240),
        },

        [`& .${tileOverlayClassName}`]: {
            padding: 0,
            width: pxToRem(240),
            height: pxToRem(240),

            [`& .${tileOverlaySlotClassNames.bottomActions}`]: {
                padding: pxToRem(12),
                justifyContent: 'flex-end',
                gap: pxToRem(10),
            },
        },
    },
});

export const ProductTagTileContainer: StyleRule = ({ theme }) => ({
    zIndex: theme.siteVariables.zIndexes.overlay,

    '& .product-tag-tile': {
        width: pxToRem(240),
    },
});
